import { render } from "./DashboardEnded.vue?vue&type=template&id=36d48548"
import script from "./DashboardEnded.vue?vue&type=script&lang=js"
export * from "./DashboardEnded.vue?vue&type=script&lang=js"
script.render = render

export default script